import { Typelockup, Heading05, Heading02, Heading04 } from '@uds/typography';
import { useMessage } from '@uds/message';
import { isObject } from '@ux/js';
import useGetSuggestions from 'domain/selectors/dst/useGetSuggestions';
import FadeInOut from 'presentation/components/common/FadeInOut';
import Shortcode from 'presentation/components/Shortcode';

export type Props = {
  className: string | undefined;
  title: string | undefined;
  precursor: string | undefined;
  subtitle: string | undefined;
  hBaseline?: number;
};

const isString = (value: unknown): value is string => {
  return typeof value === 'string' || value instanceof String;
};

const renderText = (text: string | undefined | null) => {
  if (text == null) {
    return null;
  }
  if (isString(text)) {
    return text;
  }
  if (isObject(text)) {
    return <Shortcode code={text} />;
  }
  return null;
};

const DomainSearchTypeLockup = ({ className, precursor, title, subtitle, hBaseline = 1 }: Readonly<Props>) => {
  const { data, isError, isLoading } = useGetSuggestions();
  const hideLockup = (data != null && isError === false) || isLoading;
  const errorTitle = useMessage({ id: 'usf.domainSearch.error.heading' });
  const errorSubtitle = useMessage({ id: 'usf.domainSearch.error.subheading' });
  const eyebrow = isError ? null : precursor;
  const heading = isError ? errorTitle : title;
  const subheading = isError ? errorSubtitle : subtitle;

  return (
    <FadeInOut transitionKey={hideLockup ? 'hidden' : 'visible'}>
      {hideLockup ? (
        <div />
      ) : (
        <div className={className}>
          <Typelockup
            eyebrow={<Heading05 component="p">{renderText(eyebrow)}</Heading05>}
            heading={<Heading02 depth={hBaseline}>{renderText(heading)}</Heading02>}
            subheading={<Heading04 depth={hBaseline + 1}>{renderText(subheading)}</Heading04>}
          />
        </div>
      )}
    </FadeInOut>
  );
};

export default DomainSearchTypeLockup;
